var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCuradoria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 72,
    viewBox: "6 5 12 24",
    width: 36,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100:1813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4943 11.7749L13.3999 12.4447L15.4947 14.8552L13.6631 16.2375L12.0337 13.4509L10.4042 16.2375L8.53819 14.8552L10.6032 12.5126L7.50725 11.7749L8.20603 9.56337L11.0701 10.8271L10.8382 7.61248H13.1618L12.7967 10.7718L15.7626 9.52703L16.4943 11.7749ZM18 23V1H6V23L11.9992 16.8883L18 23Z",
    fill: "#009BBF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100:1813"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: 22,
    transform: "translate(6 1)",
    width: 12
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCuradoria);
export default __webpack_public_path__ + "static/media/Logo_curadoria.46e556705fc276ef892cca68b0d0fa7d.svg";
export { ForwardRef as ReactComponent };